module.exports = __webpack_public_path__ + "img/l_d5.493b63a9.png";